import { setDefaultOptions } from 'date-fns';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isAppLanguage } from '../isAppLanguage';
import { appLanguages } from '../supported-app-languages-names';
import { dateFnsLocales } from './date-fns-locales';

export const useDateFnsLocaleEffect = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = isAppLanguage(i18n.language)
      ? dateFnsLocales[i18n.language].locale
      : dateFnsLocales[appLanguages.english].locale;

    setDefaultOptions({ locale });
  }, [i18n.language]);
};
